import { render, staticRenderFns } from "./standcostview.vue?vue&type=template&id=5e849a16&scoped=true&"
import script from "./standcostview.vue?vue&type=script&lang=js&"
export * from "./standcostview.vue?vue&type=script&lang=js&"
import style0 from "./standcostview.vue?vue&type=style&index=0&id=5e849a16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e849a16",
  null
  
)

export default component.exports